import { NgModule, Optional, SkipSelf } from '@angular/core';

import { throwIfAlreadyLoaded } from './module-import-guard';
import { SettingsService } from "../services/shared/settings.service";
import { ThemesService } from "../services/shared/themes.service";
import { MenuAdminService } from '@app/services/menuadmin/menuadmin.service';

@NgModule({
    imports: [
    ],
    providers: [
        SettingsService,
        ThemesService,
        MenuAdminService
    ],
    declarations: [
    ],
    exports: [
    ]
})
export class CoreModule {
    constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
        throwIfAlreadyLoaded(parentModule, 'CoreModule');
    }
}
